import React from "react";
import { useSetting, useSettingsActions } from "./SettingsStore.tsx";
import { SelectButton } from "primereact/selectbutton";
import { HistogramQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The histogram dial (ADR 0099 §5): what to ask.
 *
 * Basic tier, as the format's own panel is (ADR 0023 §2, as ADR 0079 applied
 * it): there is nothing else to set. The operator bar is hidden for this
 * format. Reads its own slice of the settings (ADR 0081), so a change
 * elsewhere on the panel does not redraw it.
 */
export const HistogramSettings = React.memo(function HistogramSettings() {
    const { getSettings, setSettings } = useSettingsActions();
    const { question, language } = useSetting((settings) => ({
        question: settings.HistogramQuestion,
        language: settings.Language,
    }));
    const t = useTranslation();

    function handleQuestionChange(value: HistogramQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...getSettings(), HistogramQuestion: value });
    }

    return (
        <div className="histogramSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={question}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(HistogramQuestionOptions), language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
        </div>
    );
});

export default HistogramSettings;
